import styled, { css } from 'styled-components';

import { breakpoints, Heading } from '@notino/react-styleguide';

export const TopSection = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2rem;
  margin-bottom: 2rem;

  @media (min-width: ${breakpoints.md}) {
    flex-direction: row;
    align-items: flex-start;
    margin-top: 4.125rem;
    gap: 4rem;
    margin-bottom: 0rem;
  }
`;

export const DescriptionWrapper = styled('div')`
  order: 1;
  width: 100%;
  margin-bottom: 2.5rem;

  a {
    display: none;
  }

  p {
    display: none;
  }

  @media (min-width: ${breakpoints.md}) {
    order: 2;
    margin-bottom: 0rem;

    a {
      display: inline-block;
      width: auto;
      margin-top: 2rem;
    }

    p {
      display: block;
    }
  }
`;

export const H1 = styled(Heading.H1)`
  font-size: 1.5rem !important;
  line-height: 2rem !important;
  text-align: left;
  margin: 0 !important;

  font-weight: 500 !important;
`;

export const Annotation = styled.span`
  font-size: 0.875rem;
  font-weight: 300;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  line-height: normal;
  display: block;

  @media (min-width: ${breakpoints.sm}) {
    font-size: 1.1rem;
  }
`;

export const Description = styled.p`
  margin-top: 2.5rem;
  line-height: 1.5rem;
  order: 3;

  @media (min-width: ${breakpoints.md}) {
    margin-top: 1rem;
    display: none;
  }
`;

export const BuyLink = styled('a')<{ fullWidth?: boolean }>`
  background-color: #000;
  padding: 1rem 2rem;
  color: #fff;
  order: 4;
  text-decoration: none;
  text-align: center;
  margin-top: 3.5rem;

  &:hover,
  &:active {
    color: #fff !important;
  }

  ${({ fullWidth }) =>
    fullWidth &&
    css`
      display: block;
      width: 100%;
    `}

  @media (min-width: ${breakpoints.md}) {
    display: none;
  }
`;

export const WhiteBlock = styled('div')<{ isInView: boolean }>`
  display: ${({ isInView }) => (isInView ? 'none' : 'block')};

  width: 100%;

  h1 {
    display: none;
  }

  ${({ isInView }) =>
    !isInView &&
    css`
      position: fixed;
      bottom: 0;
      z-index: 999;
      padding: 1.25rem;
      margin-top: 0rem;
      background-color: #fff;
      box-shadow: 0px -2px 5px rgba(0, 0, 0, 0.05);

      a {
        margin-top: 0rem;
      }
    `}

  @media (min-width: ${breakpoints.md}) {
    ${({ isInView }) =>
      !isInView &&
      css`
        top: 0;
        bottom: auto;
        left: 0;
        right: 0;
        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.05);

        h1 {
          display: block;
        }

        div {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-right: auto;
          margin-left: auto;
          padding-right: 0.9375rem;
          padding-left: 0.9375rem;
        }

        a {
          width: auto;
          display: block;
          margin-top: 0rem;
        }
      `}
  }
`;
